import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';

// import ConfigProvider from './common/config/Environments'; // don't remove this import statement
// ConfigProvider() // don't remove this statement
import './common/Http/axiosInterceptor'; // Import the setup file to apply interceptors globally

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
);

serviceWorker.register();
